<app-header></app-header>

<div class="container-fluid">
  <div class="row">
    <div class="col">
      <div class="configurationHeadline">
        CONFIGURATION
      </div>
    </div>
    <!-- <div class="col">
      <div class="addConfigButton">
        <button class="btn btn-dark" (click)="onClickCongig()">
          {{'Add Config' | translate}}
        </button>
      </div>
    </div>
  </div> -->
</div>

<div class="container-fluid">
  <div class="row">
    <div class="col">
      <div class="example-container mat-elevation-z1">
        <div class="example-header">
          <mat-form-field class="ml-3">
            <input matInput (keyup)="applyFilter($event.target.value)" placeholder="Filter">
          </mat-form-field>
        </div>

        <mat-table #table [dataSource]="dataSource">

          <!-- Position Column -->
          <ng-container matColumnDef="id">
            <mat-header-cell *matHeaderCellDef> No. </mat-header-cell>
            <mat-cell *matCellDef="let element"> {{element.id}} </mat-cell>
          </ng-container>

          <!-- Name Column -->
          <ng-container matColumnDef="noubaCodePattern">
            <mat-header-cell *matHeaderCellDef> Nouba Code Pattern </mat-header-cell>
            <mat-cell *matCellDef="let element"> {{element.noubCodePattern}} </mat-cell>
          </ng-container>

          <ng-container matColumnDef="edit">
            <mat-header-cell *matHeaderCellDef> Edit </mat-header-cell>
            <mat-cell *matCellDef="let element"> <mat-icon (click)="onClickConfig(element)"
                style="cursor: pointer;">edit</mat-icon></mat-cell>
          </ng-container>

          <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
          <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
        </mat-table>
      </div>
    </div>
  </div>

</div>